import { Icon as CroplerIcon } from '@cropler/ui-kit';

import styles from './styles.module.scss';

import { DewIntensityIcon } from '../GlobalComponents';
import { convertSecondsToHoursAndMinutes } from '../../utils/dates';

const CardMetric = ({ t, name, value, valueIncreasing, isDewDuration = false }) => {
  return (
    <div className={styles.cardMetric}>
      {name && <div className={styles.cardMetricName}>{name}</div>}
      {value === 0 || value ? (
        <div className={styles.cardMetricValue}>
          {isDewDuration ? (
            <div className={styles.cardMetricItem}>
              {value === 0 || value ? convertSecondsToHoursAndMinutes(value) : <span className={`${styles.cardMetricValue} text-muted`}>{t('empty.noValue')}</span>}
              <DewIntensityIcon seconds={value} />
            </div>
          ) : valueIncreasing ? (
            <>
              {value} {valueIncreasing > 0 ? <CroplerIcon name="increasing" /> : valueIncreasing < 0 ? <CroplerIcon name="increasingDown" /> : ''}
            </>
          ) : (
            value
          )}
        </div>
      ) : (
        <span className={`${styles.cardMetricValue} text-muted`}>{t('empty.noValue')}</span>
      )}
    </div>
  );
};

export default CardMetric;
